export default __webpack_public_path__ + "static/media/Arrow_Down.bc169897.png";